import React from 'react'
import { ExpertiseProps } from './Interface'
import { Grid } from '@material-ui/core'
import { Knowledge } from '../knowledge'

const Expertise: React.FC<ExpertiseProps> = ({
  refInternal,
  rules,
  errors,
  expertiseInEditModeIndex,
  onAddTag,
  onRemoveTag,
  initialValues,
  onAddExpertise,
  onEditExpertise,
  onDeleteExpertise,
  onChangeExpertiseTagLevel,
  onChangeExpertiseTagTitle,
  onChangeExpertiseTitle,
  onSubmitExpertise
}) => {
  const colors = ['#413292', '#1BA3E6', '#F26723']

  return (
    <Grid container direction={'row'} ref={refInternal}>
      {colors.map((color: string, index: number) => {
        return (
          <Grid key={index} item xs={12} md={6} className={`i-good-at-knowledge-section-${index + 1}`}>
            <Knowledge
              isInEditMode={expertiseInEditModeIndex === index}
              error={!!errors[index]}
              color={color}
              initialValues={initialValues[index]}
              rules={rules}
              onAddExpertise={onAddExpertise}
              onEditExpertise={() => onEditExpertise(index)}
              onDeleteExpertise={() => onDeleteExpertise(index)}
              onAddTag={() => onAddTag(index)}
              onRemoveTag={(tagIndex: number) => onRemoveTag(index, tagIndex)}
              onTitleChange={title => onChangeExpertiseTitle(index, title)}
              onTagLevelChange={(tagIndex, level) => onChangeExpertiseTagLevel(index, tagIndex, level)}
              onTagTitleChange={(tagIndex, title) => onChangeExpertiseTagTitle(index, tagIndex, title)}
              onSubmitExpertise={() => onSubmitExpertise(index)}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}

Expertise.defaultProps = {
  initialValues: {}
}

export default React.forwardRef((props: ExpertiseProps, ref: any) => <Expertise {...props} refInternal={ref} />)
